module.exports = __webpack_public_path__ + "static/img/12.c03368b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carruDepto/12.jpg
// module id = k9rn
// module chunks = 5